export const API = 'https://apismslaunchpad.projtest.info/api';
export const CONTAINER = 'https://apismslaunchpad.projtest.info/api/containers/storage/download';
